import axios from 'axios';

export const initAxiosInterceptors = () => {
  axios.interceptors.request.use((config) => {
    config.url = process.env.REACT_APP_API_URL + config.url;

    if (config.token) {
      const token = JSON.parse(localStorage.getItem('credentials'));
      if (!token) {
        throw new Error('token not found');
      }
      config.headers = {
        ...config.headers,
        'access-token': `Bearer ${token.access_token}`,
        Authorization: `Bearer ${token.access_token}`,
      };
    }
    if (config.token) {
      const token = JSON.parse(localStorage.getItem('credentials'));
      config.headers.Authorization = `Bearer ${token.access_token}`;
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        localStorage.removeItem('access-token');
      }
      if (error.response.status === 403) {
        localStorage.removeItem('access-token');
      }
      throw new Object({
        data: error.response.data,
        status: error.response.status,
      });
    },
  );
};
